import { DocumentText1, Clock, CloseCircle } from "iconsax-react";
import CheckIcon from "@/shared/assets/icons/CheckIcon";
import type { ResignationStatus } from "../types";

export const RESIGNATION_STATUS_MAP: Record<
  ResignationStatus,
  {
    label: string;
    color: "info" | "positive" | "notice" | "negative";
    icon: React.ReactNode;
  }
> = {
  draft: {
    label: "resignationLetter.statusLabels.draft",
    color: "info",
    icon: <DocumentText1 size={14} color="currentColor" />,
  },
  signing_pending: {
    label: "resignationLetter.statusLabels.signing_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  app_approved: {
    label: "resignationLetter.statusLabels.app_approved",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  order_pending: {
    label: "resignationLetter.statusLabels.order_pending",
    color: "notice",
    icon: <Clock size={14} color="currentColor" variant="Bold" />,
  },
  order_uploaded: {
    label: "resignationLetter.statusLabels.order_uploaded",
    color: "positive",
    icon: <CheckIcon />,
  },
  order_acknowledged: {
    label: "resignationLetter.statusLabels.order_acknowledged",
    color: "positive",
    icon: <CheckIcon />,
  },
  completed: {
    label: "resignationLetter.statusLabels.completed",
    color: "positive",
    icon: <CheckIcon />,
  },
  cancelled: {
    label: "resignationLetter.statusLabels.cancelled",
    color: "negative",
    icon: <CloseCircle size={14} color="currentColor" variant="Bold" />,
  },
} as const;
